export const fieldName = 'reassignReferencesToCode';
export const softConnectionViolation = '_SoftConnectionViolation';
export const keyCombinationViolation = '_KeyCombinationViolation';

